export default __webpack_public_path__ + "static/media/WashUColor.c564b6f6.png";